import 'Plugins/autocompletePlugin';
import 'Plugins/storageHistoryPlugin';

export default function initAutocomplete() {
	var substringMatcher = function(strs) {
		return function findMatches(q, cb) {
			var matches, substringRegex;

			matches = [];

			var substrRegex = new RegExp(q, 'i');

			jQuery.each(strs, function(i, str) {
				if (substrRegex.test(str.value)) {
					matches.push(str);
				}
			});

			cb(matches);
		};
	};

	jQuery('.search-form').each(function() {
		const form = jQuery(this);
		const field = form.find('.typeahead');
		const btnSubmit = form.find('[type="submit"]');

		fetch(form.data('autocomplete'))
			.then((res) => res.json())
			.then((loadData) => {
				initTypehead(loadData);
			});

		function initTypehead(loadData) {
			field.typeahead({
				hint: true,
				highlight: true,
				minLength: 1
			}, {
				name: 'locations',
				display: 'value',
				source: substringMatcher(loadData)
			});

			btnSubmit.on('click', (e) => {
				e.preventDefault();
				const value = field.val().trim().toLowerCase();
				let isResult = false;

				jQuery.each(loadData, function(key, obj) {
					if (obj.value.trim().toLowerCase() === value) {
						isResult = true;

						if (value.indexOf(',') !== -1) {
							if (obj.type === 'city') {
								let cityValue = value.split(',')[0].trim();
								let stateValue = value.split(',')[1].trim();

								if (cityValue.indexOf('(') !== -1) {
									cityValue = cityValue.slice(0, cityValue.indexOf('('));
								}

								if (stateValue.indexOf('(') !== -1) {
									stateValue = stateValue.slice(0, stateValue.indexOf('('));
								}

								form.trigger('onSearch', [{
									value: cityValue,
									type: 'city'
								}, {
									value: stateValue,
									type: 'state'
								}]);
							} else if (obj.type === 'state') {
								let stateValue = value.split(',')[0].trim();

								if (stateValue.indexOf('(') !== -1) {
									stateValue = stateValue.slice(0, stateValue.indexOf('('));
								}

								form.trigger('onSearch', [{
									value: stateValue,
									type: 'state'
								},]);
							}
						} else {
							let stateValue = value;

							if (stateValue.indexOf('(') !== -1) {
								stateValue = stateValue.slice(0, stateValue.indexOf('('));
							}

							form.trigger('onSearch', [{
								value: stateValue,
								type: obj.type
							}]);
						}
					}
				});

				if (!isResult) {
					form.trigger('onSearch', null);
				}

				if (form.data('redirect')) {
					window.location.href = form.data('redirect') + window.location.search;
				}
			});
		}

		form.on('onSearch', function(e, ...values) {
			if (window.history && window.history.pushState) {
				window.StorageHistory.reset();
			}

			for (let i = 0; i < values.length; i++) {
				const type = values[i].type;
				let value = values[i].value;

				if (value.indexOf('(') !== -1) {
					value = value.slice(0, value.indexOf('('));
				}

				if (window.history && window.history.pushState) {
					window.StorageHistory.set(type, value);
				}
			}
		}).on('submit', function(e) {
			e.preventDefault();
		});
	});
}